export default __webpack_public_path__ + "static/media/add.9ad46945.mp3";